'use client';

import { useActionState, useState } from 'react';
import Link from 'next/link';
import { Mail, ArrowRight, Loader2, ArrowLeft, CheckCircle2 } from '@/lib/icons';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { requestPasswordReset } from '../login/actions';

export default function ForgotPasswordClient() {
  const [email, setEmail] = useState('');
  const [state, formAction, pending] = useActionState(requestPasswordReset, null);

  // Once the action returns success, we show a confirmation panel instead
  // of the form — the message is intentionally vague so an outside
  // observer can't enumerate accounts.
  const sent = !!state?.info;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm bg-card border border-border rounded-2xl p-6 space-y-5 shadow-xl">
        <div>
          <Link
            href="/login"
            className="inline-flex items-center gap-1.5 text-xs text-foreground hover:text-foreground mb-4"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to sign in
          </Link>
          <h1 className="text-xl font-bold">Reset your password</h1>
          <p className="text-xs text-foreground mt-1">
            Enter the email you signed up with. We'll send you a link to choose a new password.
          </p>
        </div>

        {sent ? (
          <div className="bg-secondary/60 border border-border rounded-xl p-4 flex items-start gap-3">
            <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0 mt-0.5" />
            <p className="text-xs text-foreground leading-relaxed">{state.info}</p>
          </div>
        ) : (
          <form action={formAction} className="flex flex-col gap-4">
            <div>
              <Label className="text-xs mb-1.5 block">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-foreground" />
                <Input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="pl-9"
                  autoComplete="email"
                  required
                />
              </div>
            </div>
            {state?.error && (
              <p className="text-xs text-destructive bg-destructive/10 border border-destructive/20 rounded-lg px-3 py-2">
                {state.error}
              </p>
            )}
            <Button type="submit" disabled={pending} className="w-full h-10 font-semibold rounded-xl gap-2">
              {pending ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <>
                  <span>Send reset link</span>
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
